// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/rdo-cars-observer-communicator.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/rdo-cars-observer-communicator/apron-advisory-service.js';
import g1 from '../lessons/air-law/rdo-cars-observer-communicator/mfau.js';
import g2 from '../lessons/air-law/rdo-cars-observer-communicator/private-advisory-station.js';
import g3 from '../lessons/air-law/rdo-cars-observer-communicator/rdo-cars-observer-communicator.js';

mount([g0, g1, g2, g3]);
